module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-125.0a18bc20.jpg";